<template>
  <button :class="[$style.wrapper, $style[color], large && $style.large]" @click="$emit('click')"><slot /></button>
</template>
<script>
export default {
  name: 'v-btn',
  props: {
    color: String,
    large: Boolean,
  },
}
</script>
<style lang="scss" module>
.wrapper {
  //@include vtFont;
  border: 0;
  font-weight: normal;
  background: #fff;
  border-radius: 0.5rem;
  height: 4.2rem;
  line-height: 4.2rem;
  font-size: 1.6rem;
  text-align: center;
  min-width: 11rem;
  padding: 0 1rem;
  outline: none;
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.2s ease;
  transform-origin: center;
  text-transform: uppercase;
  user-select: none;

  &:hover {
    opacity: 0.6;
  }

  &:active {
    transform: scale(0.9);
  }

  &[disabled] {
    background: #B8B8C6;
    opacity: 0.6;
  }
}

.large {
  height: 6rem;
  line-height: 6rem;
  min-width: 16.6rem;
}

.green {
  background: #09E56E;
  color: #fff;
}

.black {
  background: #000;
  color: #fff;
}
</style>
